import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useConfig } from '../context/ConfigContext';
import api from '../api/axios';
import Header from '../components/Header';
import ActionButton from '../components/ActionButton';

const Login = () => {
    const { login } = useAuth();
    const { config, loading: configLoading } = useConfig();
    const [loginInput, setLoginInput] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [viewMode, setViewMode] = useState('landing'); // 'landing' or 'login'
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        const result = await login(loginInput);
        if (result.success) {
            try {
                await api.post('/sessions/log', {
                    page_name: 'login',
                    action_type: 'login'
                });
            } catch (err) {
                console.error("Failed to log login action", err);
            }
            navigate('/');
        } else {
            setError(result.message);
            setIsLoading(false);
        }
    };

    if (configLoading) {
        return (
            <div className="min-h-screen bg-[#1c0042] flex items-center justify-center">
                <div className="w-10 h-10 border-4 border-white/20 border-t-white rounded-full animate-spin"></div>
            </div>
        );
    }

    const bgImage = config?.pageDesigns?.login?.bgImage || config?.backgroundImage || '/assets/fondo_body.png';

    return (
        <div className="min-h-screen flex flex-col relative overflow-x-hidden transition-all duration-700 bg-[#1c0042] font-sans items-center pb-20 pt-10">
            {/* Background Layer */}
            {bgImage && (
                <div
                    className="fixed inset-0 z-0 pointer-events-none"
                    style={{
                        backgroundImage: `url(${bgImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        backgroundAttachment: 'fixed',
                    }}
                ></div>
            )}

            <Header />

            {/* Content Area */}
            <div className="w-full max-w-xs z-10 flex-grow flex flex-col justify-center animate-fadeIn">

                {viewMode === 'landing' && (
                    <div className="space-y-6 w-full mt-8">
                        <ActionButton
                            variant="primary"
                            onClick={() => navigate('/register')}
                        >
                            Registro
                        </ActionButton>

                        <ActionButton
                            variant="primary"
                            onClick={() => setViewMode('login')}
                        >
                            Iniciar Sesión
                        </ActionButton>
                    </div>
                )}

                {viewMode === 'login' && (
                    <div className="space-y-8 w-full mt-4 bg-black/20 p-8 rounded-[40px] backdrop-blur-md border border-white/10 shadow-2xl">
                        <div className="text-center">
                            <h3 className="text-2xl font-black text-white italic uppercase tracking-tighter">Bienvenido</h3>
                            <p className="text-xs text-white/60 uppercase tracking-widest mt-2">Ingresa tus datos</p>
                        </div>
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div className="space-y-2">
                                <label className="text-[10px] uppercase font-black tracking-[0.3em] text-white/40 pl-2">
                                    {config?.registration_fields?.identification === false ? 'Email' : 'Identificación'}
                                </label>
                                <input
                                    className="w-full bg-white/5 border border-white/10 p-5 rounded-[30px] focus:outline-none focus:ring-4 focus:ring-purple-500/20 transition-all font-bold text-white text-center shadow-2xl placeholder:text-white/20"
                                    placeholder={config?.registration_fields?.identification === false ? 'tu@email.com' : 'Ej: 12345678'}
                                    value={loginInput}
                                    onChange={(e) => setLoginInput(e.target.value)}
                                    required
                                />
                            </div>

                            {error && (
                                <div className="bg-red-500/20 text-red-200 p-4 rounded-2xl text-[10px] font-black uppercase tracking-widest border border-red-500/30 text-center animate-shake">
                                    {error}
                                </div>
                            )}

                            <ActionButton variant="primary" onClick={handleSubmit} className="!w-full !max-w-full !mt-8">
                                {isLoading ? 'Accediendo...' : 'Ingresar'}
                            </ActionButton>

                            <button
                                type="button"
                                onClick={() => setViewMode('landing')}
                                className="w-full text-white/40 text-[10px] font-black uppercase tracking-widest hover:text-white transition-colors pt-4"
                            >
                                ← Volver
                            </button>
                        </form>
                    </div>
                )}
            </div>

            {/* Bottom AstraZeneca Logo (For Login page specific layout) */}
            <div className="hidden mt-auto pt-12 z-10 w-full max-w-xs flex justify-center pb-8 opacity-80 pointer-events-none">
                <img
                    src="/assets/astrazeneca.png"
                    alt="AstraZeneca"
                    className="w-[120px] h-auto opacity-50 mix-blend-screen"
                />
            </div>

            {/* Knot Glow / Floor Decor */}
            <div className="fixed bottom-0 left-0 right-0 h-[20vh] bg-gradient-to-t from-purple-900/40 to-transparent pointer-events-none z-0"></div>
            <footer className="w-full p-6 flex justify-center items-center z-40 relative">
                <img
                    src="/assets/texto_footer.png"
                    alt="Información Legal"
                    className="h-auto w-[90%] max-w-[600px] opacity-80"
                />
            </footer>
        </div>

    );
};

export default Login;
